<div class="route_sign_post signpost_details">
  @for (road of roads; track trackByFn($index)) {
    <div class="prefix signposts">
      @if (road.Prefix.length) {
          @for (prefix of road.Prefix; track trackByFn($index)) {
              @if (prefix.icon) {
                <div class="{{'icon-'+prefix.icon}} signpost_prefix_icon middle"></div>
              }
              <div class="route_signPost_prefix">{{prefix.name}}</div>
          }
      }
    </div>
  }
  <div class="signpost_wrapper">
    @for (road of roads; track trackByFn($index)) {
      <div class="signposts">
        @if (road.Text.length) {
            @for (text of road.Text; track trackByFn($index)) {
              <div class="signpost_text">{{text}}
                @if (road.Icon) {
                  <div class="{{'icon-'+road.Icon}} signpost_icon"></div>
                }
              </div>
            }
        }
        @if (road.Name.length) {
            @for (name of road.Name; track trackByFn($index)) {
                <div class="signpost_roadname">{{name}}</div>
                @if (road.Icon) {
                  <div class="{{'icon-'+road.Icon}} signpost_icon"></div>
                }
            }
        }
      </div>
    }
  </div>
  @for (road of roads; track trackByFn($index)) {
    <div class="suffix signposts">
      @if (road.Suffix.length) {
          @for (suffix of road.Suffix; track trackByFn($index)) {
              @if (suffix.icon) {
                <div class="{{'icon-'+suffix.icon}} signpost_suffix_icon middle"></div>
              }
              <div class="route_signPost_suffix">{{suffix.name}}</div>
          }
      }
    </div>
  }
</div>